/**
 * A remembered scope: the `family × assettype` a preference is stored under.
 *
 * The one word "scope" is reserved for this. A change to what a scope remembers
 * is a `RememberedScopePatch`, and which scope a search falls in is
 * `scopeRememberedFor`.
 *
 * Distinct from `SearchModeEnum`, which is a different axis entirely (standard,
 * event, artist, moreLikeThis, …). Preference storage keys off this one only;
 * the two must not be conflated.
 *
 * `ANALOG_FILM` is a storage slot — cookie field `af`, and a
 * `SearchPreferences.analogFilm` entry. No search resolves to it.
 */
export enum PreferenceScopeEnum {
  CREATIVE_IMAGE = 'creativeImage',
  EDITORIAL_IMAGE = 'editorialImage',
  MIXED_IMAGE = 'mixedImage',
  CREATIVE_FILM = 'creativeFilm',
  EDITORIAL_FILM = 'editorialFilm',
  MIXED_FILM = 'mixedFilm',
  ANALOG_FILM = 'analogFilm',
  CREATIVE_IMAGE_FILM = 'creativeImageFilm',
}

/**
 * Whether this scope stores a nudity choice.
 *
 * Creative image and creative image-and-film are the scopes that remember one.
 * `applyDefaults` fills the same two, and its test fails if the two stop
 * agreeing. Where a search offers the filter is a separate question: a search
 * can offer it without this scope storing a choice.
 */
export const isNudityFilterScope = (
  scope: PreferenceScopeEnum | undefined
): boolean =>
  scope === PreferenceScopeEnum.CREATIVE_IMAGE ||
  scope === PreferenceScopeEnum.CREATIVE_IMAGE_FILM;
